const meta = {
  requiresAdmin: true,
  requiresAuth: true
}

export const routes = [
  {
    path: '/eventos',
    component: () => import(/* webpackChunkName: "events" */ './components/EventsCalendar'),
    meta,
    name: 'events'
  }
]
